const GoogleAnalytics = (analyticsIDs = { ga_id: '', gm_id: '' }, options) => {
    // If there is no ga or gtag on the page, drop out
    if (!window.ga && !window.gtag) {
        return;
    }

    /* 
        When the ga tag first fires, it creates a hitcount in window.gaData[id] for each id 
        If there is already a value for this, we don't want to fire the create or config events again
    */
    const hasGAData = id => {
        return window.gaData && window.gaData[id];
    };

    const initialize = () => {
        const { ga_id, gm_id } = analyticsIDs;
        /* Dev Note:
            Google has many ways to load and interact with their analytics solutions.
            * Classic Analytics
            - Classic Analytics uses analytics.js and creates a global _gaq object. 
              We shouldn't have to worry about this but it's worth noting because it 
              may exist on the page.
            * Universal Analytics
            - Universal Analytics uses analytics.js and creates a global ga object.

        */

        /* If the customer site is using Universal Analytics without the Global Site Tag, send the create event using ga
         * If the customer site is using Global Site Tag, send the config event using gtag
         */
        if (ga_id && ga_id.length && window.ga && !window.gtag) {
            if (!hasGAData(ga_id)) {
                window.ga('create', ga_id, options || 'auto');
            }
        } else if (window.gtag) {
            if (ga_id && ga_id.length && (!gm_id || !gm_id.length)) {
                if (!hasGAData(ga_id)) {
                    window.gtag('config', ga_id);
                }
            } else if (gm_id && gm_id.length) {
                window.gtag('config', gm_id);
            }
        }

        window.addEventListener('CONVERSION_CLOUD_EVENT', evt => {
            const { type, payload } = evt.detail;

            if (type !== 'GA_EVENT' || (ga_id && ga_id.length === 0 && gm_id && gm_id.length === 0)) {
                return;
            }

            const { action, module, category } = payload;
            const name = getModuleName(module);

            /* According to the following article, Google supports dual tagging (both UA and GA4) using gtag for the same property:
            https://support.google.com/analytics/answer/11091026?hl=en#zippy=%2Cin-this-article

            The following is the correct way to send events to both GA4 and UA using gtag:
            window.gtag('event', action, {
                event_category: category,
                event_label: label,
                value: value
            })

            If we have gtag, send the event as formatted in the previous comment.
            If not, check to see if we have ga and send using the Universal format.
            */
            if (window.gtag && ((ga_id && ga_id.length) || (gm_id && gm_id.length))) {
                window.gtag('event', `${category} - ${action} - ${name}`, {
                    event_action: action,
                    event_category: category,
                    event_label: name
                });
            } else if (window.ga && ga_id && ga_id.length) {
                window.ga(`${GA_TRACKER_NAME}.send`, {
                    hitType: 'event',
                    eventCategory: category,
                    eventAction: action,
                    eventLabel: name
                });
            }
        });
    };

    return {
        initialize
    };
};

const getModuleName = module => {
    switch (module) {
        case 'MODULE_BPN':
            return 'BPN';
        case 'MODULE_CALLUS':
            return 'CallUs';
        case 'MODULE_CHATBOT':
            return 'VirtualAssistant';
        case 'MODULE_CONCESSIONMANAGER':
            return 'Spotlight';
        case 'MODULE_INCOMECALCULATOR':
            return 'IncomeCalculator';
        case 'MODULE_SCHEDULEGENIE':
            return 'ScheduleGenie';
        default:
            return '';
    }
};

export const GA_TRACKER_NAME = 'tccTracker';

export default GoogleAnalytics;
